import React from 'react';
import { metrics } from '../../data/content';
export function Metrics() {
  return <section className="w-full bg-white px-4 py-10" aria-label="Resultados" data-id="element-196" data-mp="2c7dffh4ev4cq">
      <div className="mx-auto grid w-full max-w-4xl grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4" data-id="element-197" data-mp="2c5afo5dghwut">
        {metrics.map(metric => <div key={metric.label} className="text-center" data-id="element-198" data-mp="2m519s5y3u9ud">
            <div className="font-display text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-199" data-mp="2m3gege3yumvg">
              {metric.value}
            </div>
            <p className="mx-auto mt-2 max-w-[160px] text-[11px] font-semibold uppercase leading-snug tracking-wide text-navy/55 sm:text-xs" data-id="element-200" data-mp="2uy4mgc0xeiny">
              {metric.label}
            </p>
          </div>)}
      </div>
    </section>;
}